export function createCloudSyncLifecycleController() {
  let generation = 0;
  let ownerKey = null;

  return Object.freeze({
    activate(nextOwnerKey) {
      generation += 1;
      ownerKey = String(nextOwnerKey || "");
      return Object.freeze({ generation, ownerKey });
    },
    invalidate() {
      generation += 1;
      ownerKey = null;
    },
    capture(expectedOwnerKey) {
      const expected = String(expectedOwnerKey || "");
      if (!ownerKey || ownerKey !== expected) return null;
      return Object.freeze({ generation, ownerKey });
    },
    isActive(fence, expectedOwnerKey = fence?.ownerKey) {
      return Boolean(
        fence &&
          fence.generation === generation &&
          fence.ownerKey === ownerKey &&
          fence.ownerKey === String(expectedOwnerKey || ""),
      );
    },
  });
}
